import React, {FC, useEffect, useRef, useState} from 'react'
import {StepperComponent} from '../../../../../template/_metronic/assets/ts/components'
import WizardBody from './WizardBody'
import WizardNavbar from './header/WizardNavbar'
import {WizardProvider} from './core/WizardContext'
import {
  useCancelBatchMutation,
  useGetPendingListBatchQuery,
} from '../../../../../redux/api/services/batch'
import ModalComponent from '../../../../../libs/_fri/components/CustomModal/CustomModal'
import {
  setCurrentBatchDetails,
  deleteCurrentBatchDetails,
} from '../../../../../redux/slices/batchDetailsSlice'
import {useDispatch, useSelector} from 'react-redux'
import {RootState} from '../../../../../redux/store'
import {TitleCard} from '../../../../../helpers/elements/card/TitleCard'
import {CustomErrorAlert} from '../../../../../libs/_fri/components/CustomErrorAlert/CustomErrorAlert'

const Wizard: FC = () => {
  const dispatch = useDispatch()
  const [cancelBatch, cancelBatchStatus] = useCancelBatchMutation()
  const infoState = useSelector((state: RootState) => state.info)

  const {data: pendingList, refetch} = useGetPendingListBatchQuery({info: infoState})
  const currentBatch = useSelector((state: RootState) => state.batchDetailsSlice)

  const [showModal, setShowModal] = useState(false)
  const [showCancelModal, setShowCancelModal] = useState(false)
  const [isSuccessForm, setIsSuccessForm] = useState(false)

  const stepperRef = useRef<HTMLDivElement | null>(null)
  const stepper = useRef<StepperComponent | null>(null)

  const loadStepper = () => {
    stepper.current = StepperComponent.createInsance(stepperRef.current as HTMLDivElement)
  }

  const prevStep = () => {
    if (!stepper.current) {
      return
    }
    dispatch(deleteCurrentBatchDetails())
    refetch()
    // stepper.current.goPrev()
  }

  const submitStep = () => {
    if (!stepper.current) {
      return
    }
    if (stepper.current.currentStepIndex !== stepper.current.totalStepsNumber) {
      stepper.current.goNext()
    }
  }

  useEffect(() => {
    if (!stepperRef.current) return
    loadStepper()
  }, [stepperRef])

  useEffect(() => {
    if (isSuccessForm) {
      dispatch(deleteCurrentBatchDetails())
      stepper.current?.goto(3)
      return
    }

    if (currentBatch.batchId !== '') {
      stepper.current?.goto(2)
      return
    }

    if (pendingList?.responseContent.batches && pendingList?.responseContent.batches.length > 0) {
      setShowModal(true)
    } else {
      setShowModal(false)
    }
    stepper.current?.goFirst()
  }, [currentBatch, pendingList, isSuccessForm])

  useEffect(() => {
    if (!cancelBatchStatus.isSuccess) return

    setShowCancelModal(false)
    dispatch(deleteCurrentBatchDetails())
    refetch()
    // stepper.current?.goFirst()
  }, [cancelBatchStatus.isSuccess])

  const cancelProcess = (batchId: string) => {
    cancelBatch({info: infoState, requestContent: {batchId: batchId}})
  }

  return (
    <>
      <TitleCard title='Nuevo pago fri' subtitle='Programar pago planilla'>
        {currentBatch.batchId !== '' && (
          <button
            className='btn btn-primary rounded-pill fs-3'
            onClick={() => {
              setShowCancelModal(true)
            }}
          >
            Cancelar proceso
          </button>
        )}
      </TitleCard>

      <div className='card'>
        <div className='card-body'>
          <div ref={stepperRef} className='stepper stepper-links'>
            {showModal && (
              <ModalComponent
                size={'md'}
                variant={'primary'}
                handleConfirm={() => {
                  if (!pendingList?.responseContent.batches[0].id) return

                  const firstBatch = pendingList.responseContent.batches[0]
                  dispatch(
                    setCurrentBatchDetails({
                      totalRecords: firstBatch.totalRecords,
                      invalidRecords: firstBatch.totalRecords - firstBatch.validRecords,
                      validRecords: firstBatch.validRecords,
                      totalAmount: firstBatch.amount,
                      payableAmount: firstBatch.paidAmount,
                      batchId: firstBatch.id,
                      batchTitle: '',
                      reference: '',
                      notificationEmail: firstBatch.notificationEmail,
                    })
                  )
                  setShowModal(false)
                  submitStep()
                }}
                handleClose={() => {
                  if (!pendingList?.responseContent.batches[0].id) return
                  const firstBatch = pendingList.responseContent.batches[0]
                  cancelProcess(firstBatch.id)
                }}
                textCancel={'Deshacer'}
                textConfirm={'Continuar'}
                closeButton={false}
                backdrop={'static'}
              >
                <CustomErrorAlert
                  show={cancelBatchStatus.isError}
                  error={cancelBatchStatus.error}
                  close={cancelBatchStatus.reset}
                />
                <div className='d-flex  flex-column text-center'>
                  <div className='fs-2x fw-semibold text-primary-dark'>Proceso pendiente</div>
                  <div className='fs-2 text-gray px-22'>
                    Tiene un lote de pago en proceso ¿Desea continuar o deshacer el proceso?
                  </div>
                </div>
              </ModalComponent>
            )}

            {showCancelModal && (
              <ModalComponent
                size={'md'}
                variant={'danger'}
                handleConfirm={() => {
                  cancelProcess(currentBatch.batchId)
                }}
                handleClose={() => {
                  setShowCancelModal(false)
                }}
                textCancel={'Continuar'}
                textConfirm={'Confirmar'}
                closeButton={false}
                backdrop={'static'}
              >
                <CustomErrorAlert
                  show={cancelBatchStatus.isError}
                  error={cancelBatchStatus.error}
                  close={cancelBatchStatus.reset}
                />
                <div className='d-flex  flex-column text-center'>
                  <div className='fs-2x fw-semibold text-primary-dark'>Proceso pendiente</div>
                  <div className='fs-2 text-gray px-22'>
                    Tiene un lote de pago en proceso ¿Desea continuar o deshacer el proceso?
                  </div>
                </div>
              </ModalComponent>
            )}
            <WizardProvider
              submitStep={() => {
                setIsSuccessForm(true)
              }}
              nextStep={submitStep}
              prevStep={prevStep}
            >
              <WizardNavbar />
              <WizardBody />
            </WizardProvider>
          </div>
        </div>
      </div>
    </>
  )
}

export {Wizard}
